import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { take } from 'rxjs/operators';
import { AuthorizeService, IUser } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from '../../services/user.service';
import { UserSettings } from '../../models/player.model';


@Component({
  selector: 'tournament16',
  templateUrl: './tournament16.component.html',
  styleUrls: ['./tournament16.component.scss']
})
export class Tournament16Component implements OnInit {
  public busy: boolean;
  public tournamentBracket = {};
  public feedInTournamentBracket = {

    round1: [],
    round2: [],
    round4: [],
    round8: [
      
{player: new Player({id: "71fc418c-f69f-42c9-abd9-e249595082be", lastName: "Wayne", firstName: "Dean "})  , score: null},
{player: new Player({id: "f5a1abd1-9400-44a8-ab49-88d0373fd64f", lastName: "Veselov", firstName: "Roman"}), score: null},
{player: new Player({id: "9f4c0414-d21e-433c-a1bd-d80e139fc184", lastName: "Weiss", firstName: "Farley"}), score: null},
{player: new Player({id: "7a58654c-e72a-4a8e-89ab-6ddaec4eed08", lastName: "Zuniga", firstName: "Hiram"}), score: null},
{player: new Player({id: "47b487b5-a101-4246-a3fa-0f0f00f6f84b", lastName: "Baum", firstName: "Jason"}), score: null},
{player: new Player({id: "cdfe8d8f-37f7-4256-be19-8a19bf0a1178", lastName: "Brusey", firstName: "Greg"}), score: null}, 
{player: new Player({id: "8708b4ea-3c4c-4642-a0ba-5fe75ae8565b", lastName: "Hirsch", firstName: "Jake"}), score: null},
{player: new Player({id: "98403fb5-0590-4fc9-9769-c8ea94ae62af", lastName: "Peltz", firstName: "Dan"}), score: null}

    ]
  };
  public faTrophy = faTrophy;
  public showRecord: boolean = false;
  public queryFailed: boolean = false;
  public retryCount: number = 0;

  constructor(private http: HttpClient, private authorizeSvc: AuthorizeService,
    private route: ActivatedRoute,
    private router: Router, private userSvc: UserService) {
    this.busy = true;
  }

  public ngOnInit() {
    this.busy = true;
    this.http.get<any>('/api/tournament16').subscribe(
      (resp) => {
        // Check if this is a 16-player tournament (has round16)
        const hasRound16 = resp.round16 && resp.round16.length > 0;
        const tournamentPlayers = hasRound16 
          ? resp.round16.map(r => r.player?.id).filter(r => r && !r.startsWith('00000000-0000'))
          : resp.round8.map(r => r.player?.id).filter(r => r && !r.startsWith('00000000-0000'));

        // turn on/off record button
        this.authorizeSvc.getUser().pipe(take(1)).subscribe((u) => {
          this.showRecord = (tournamentPlayers.includes(u.sub) || u.sub == 'acfc2497-cb44-4394-b866-3f546b306ff6')
            //&& resp.round1[0].score == null
        });

        // Handle round16 (first round for 16-player tournaments)
        if (hasRound16) {
          this.tournamentBracket['round16'] = [];
          for (const n of resp.round16) {
            if (n.player)
              this.tournamentBracket['round16'].push({ player: new Player(n.player), score: n.score });
            else
              this.tournamentBracket['round16'].push({});
          }
        }

        // Handle round8 (quarterfinals for 16-player, initial players for 8-player)
        this.tournamentBracket['round8'] = [];
        for (const n of resp.round8) {
          if (n.player)
            this.tournamentBracket['round8'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round8'].push({});
        }

        // Handle round4 (semifinals for 16-player, quarterfinals for 8-player)
        this.tournamentBracket['round4'] = [];
        for (const n of resp.round4) {
          if (n.player)
            this.tournamentBracket['round4'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round4'].push({});
        }

        // Handle round2 (final for 16-player, semifinals for 8-player)
        this.tournamentBracket['round2'] = [];
        for (const n of resp.round2) {
          if (n.player)
            this.tournamentBracket['round2'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round2'].push({});
        }

        // Handle round1 (champion)
        this.tournamentBracket['round1'] = [];
        for (const n of resp.round1) {
          if (n.player)
            this.tournamentBracket['round1'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round1'].push({});
        }
        this.busy = false;
      },
      (err) => { 
        this.busy = false;
        const queryParamMap = this.route.snapshot.queryParamMap;
        if(parseInt(queryParamMap.get('retry')||'', 10) > 0 ) {
          this.queryFailed = true;
          return;
        }
        else this.retryCount++;

        const ladderId = this.route.snapshot.paramMap.get('ladderId') || '';
        this.userSvc.getLaddersAndLevels().subscribe(
          (resp: UserSettings[]) => {
            const validOne = resp.find(r => r.ladderId == ladderId && r.levelId > 1);
            if( validOne ) {
              this.userSvc.clearCache();
              localStorage.setItem('ladderId', validOne.ladderId);
              localStorage.setItem('levelId', validOne.levelId.toString());
              this.router.navigate(['/tournament16', ladderId], {queryParams: { retry: this.retryCount++ }});
            }
            else {
              const validOne = resp.find(r => r.ladderId == ladderId );
              if(validOne) {
                this.userSvc.clearCache();
                localStorage.setItem('ladderId', validOne.ladderId);
                localStorage.setItem('levelId', '1');
                this.router.navigate(['/alltournament'], {queryParams: { retry: this.retryCount++ }});
              }
              else {
                this.queryFailed = true;
              }
            }
          }
        );
      }
    )
  }
}

